/**
 * To update the list of browser polyfills, please see polyfill.base.ts
 * Note: polyfill.base.ts is included via the tsconfig.base.json
 */

import 'polyfill.base';

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

import cssVars from 'css-vars-ponyfill';

cssVars({
  watch: true,
  shadowDOM: true,
});
